/**
 * Отображение текущей выплаты
 */

import * as PIXI from 'pixi.js';
import { TextStyle } from 'pixi.js';
import { COLORS } from '@/config/colors';
import type { Lang } from '@/utils/storage';

const TEXTS = {
  ru: { payout: 'Выплата' },
  en: { payout: 'Payout' },
};

export class PayoutDisplay extends PIXI.Container {
  private label: PIXI.Text;
  private value: PIXI.Text;

  constructor() {
    super();
    this.label = new PIXI.Text(
      TEXTS.ru.payout,
      new TextStyle({
        fontFamily: '"Jost"',
        fontSize: 16,
        fill: COLORS.textPanel,
      })
    );
    this.label.anchor.set(0.5);
    this.value = new PIXI.Text(
      '$0.00',
      new TextStyle({
        fontFamily: '"Jost"',
        fontSize: 22,
        fill: COLORS.gold,
        fontWeight: 'bold',
      })
    );
    this.value.anchor.set(0.5);
    this.value.y = 25;
    this.addChild(this.label);
    this.addChild(this.value);
  }

  setPayout(payout: number): void {
    this.value.text = `$${payout.toFixed(2)}`;
    if (payout > 0) {
      this.value.style.fill = COLORS.gold;
    } else {
      this.value.style.fill = COLORS.textPanel;
    }
  }

  setLang(lang: Lang): void {
    this.label.text = TEXTS[lang].payout;
  }
}
